import React, {Component} from 'react';
import { Field } from 'formik';

class Checkbox extends Component {
    // state = {
    //     checked: false
    // };

    // componentDidMount(){
    //     const { value } = this.props;
    //     if (typeof value !== 'undefined'){
    //         this.setState()
    //     }
    // }

    // handleChange = (e) => {
    //     this.setState({ checked: e.target.checked });
    // };

    render() {
        // const { checked } = this.state;
        const { label, labelClass, labelStyle, name, modifiers, checked, form, onChange, ...rest } = this.props;

        const props = {};
        props.className = 'checkbox';
        
        if (modifiers) modifiers.forEach(m => props.className+= ` checkbox--${m}`);

        // If using Formik, use Field component (has all the bindings)
        const FieldTag = form ? Field : 'input';

        const attrs = {};
        
        if (typeof checked !== 'undefined') attrs.checked = checked;
        if (typeof onChange !== 'undefined') attrs.onChange = onChange;

        return (
            <div {...props}>
                <FieldTag 
                    id={name}
                    name={name}
                    type={`checkbox`}
                    className={`checkbox__input`}
                    // onChange={this.handleChange}
                    // checked={checked}
                    {...rest}
                    {...attrs}
                />
                <label 
                    className={`checkbox__label ` + labelClass}
                    style={labelStyle}
                    htmlFor={name}
                    dangerouslySetInnerHTML={{__html: label ? label.text : ''}}
                /> 
            </div>
        );
    }
}

export { Checkbox };